import type { Scene } from '../../types/scene';
import type { SCENE_EDIT_MODE_EDITING, SCENE_EDIT_MODE_VIEWING } from './scene.selectors';

export type SceneEditMode = typeof SCENE_EDIT_MODE_VIEWING | typeof SCENE_EDIT_MODE_EDITING;

export interface Position {
  id: string;
  x: number;
  y: number;
}
export interface SceneState {
  scenes: Record<string, Scene>;
  currentSceneId?: string;
  currentNodePositions: Position[];
  sceneLoadingStatus: SceneLoadingStatus;
  editMode: SceneEditMode;
  startWithNewScene: boolean;
  startDeepLinkedScene: string | null;
  showViewingModeMessage: boolean;
  startWithProvidedGraph: {
    id?: string;
    nodes: Position[];
    relationships: string[];
  } | null;
}

export const REFRESH_SCENES_ACTION = 'scene/refreshScenes';

export type SceneLoadingStatus = 'loading' | 'inventory' | 'pending' | 'idle';
